import { Navigate } from 'react-router-dom';
import { AdminPanel } from '../components/Admin/AdminPanel';
import { useAuthState } from '../components/Layout/AuthGate';

export function AdminPage() {
  const auth = useAuthState();
  if (auth.role !== 'admin') return <Navigate to="/" replace />;
  return <AdminPanel />;
}
